import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import TaniumLogo from '../../static/tanium_logo.svg';

const DEFAULT_LOGO_HEIGHT = 24;

export const Logo: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <Link to="/">
      <img src={TaniumLogo} alt={t('Tanium logo')} height={DEFAULT_LOGO_HEIGHT} />
    </Link>
  );
};
